import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useRepositories } from '../../../infrastructure/http/RepositoryProvider';
import type { ClaimedHub } from '../../../domain/Hub';
import type { Site } from '../../../domain/Site';

// Vincular un hub con el código de su etiqueta. Llega con ?hub=&codigo= desde
// el QR (cámara o lector de la app) o se tipea a mano.
export function useClaimHub() {
  const location = useLocation();
  const history = useHistory();
  const { hubs, sites: sitesRepo } = useRepositories();
  const params = new URLSearchParams(location.search);

  const [hubId, setHubId] = useState(params.get('hub') ?? '');
  const [code, setCode] = useState(params.get('codigo') ?? '');
  const [siteId, setSiteId] = useState<string | null>(null);
  const [sites, setSites] = useState<Site[]>([]);
  const [claiming, setClaiming] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [result, setResult] = useState<ClaimedHub | null>(null);

  useEffect(() => {
    sitesRepo
      .list()
      .then(({ sites }) => {
        setSites(sites);
        // Con un solo campo, el hub va ahí sin preguntar.
        if (sites.length === 1) setSiteId(sites[0].id);
      })
      .catch(() => setSites([]));
  }, [sitesRepo]);

  const claim = async () => {
    setError(null);
    if (!hubId.trim() || !code.trim()) {
      setError('Completá el id del hub y el código de la etiqueta.');
      return;
    }
    setClaiming(true);
    try {
      setResult(await hubs.claim({ hubId: hubId.trim().toLowerCase(), code: code.trim(), siteId }));
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se pudo vincular el hub.');
    } finally {
      setClaiming(false);
    }
  };

  return {
    hubId,
    setHubId,
    code,
    setCode,
    // Llegó del QR: id y código ya están, solo falta confirmar.
    fromQr: Boolean(params.get('hub') && params.get('codigo')),
    siteId,
    setSiteId,
    sites,
    claiming,
    error,
    result,
    claim,
    goToStations: () => history.replace('/app/devices'),
  };
}
